import React from "react";
import { FaArrowUp, FaArrowDown, FaCheckCircle, FaTimes, FaSpinner, FaChevronDown, FaChevronUp, FaExclamationCircle, FaBan } from 'react-icons/fa';

const TransferList = ({ transfers, isOpen, toggleOpen, removeTransfer, clearTransfers }) => {
  // Sort transfers so that the latest (highest id or most recent) come first.
  const sortedTransfers = [...transfers].sort((a, b) => b.id - a.id);

  // Render nothing if there are no transfers.
  if (!transfers || transfers.length === 0) return null;

  return (
    <div className="fixed bottom-4 left-4 bg-gray-800 text-white rounded-lg shadow-lg w-96">
      {/* Header with toggle and Clear All button */}
      <div className="flex justify-between items-center p-4 bg-gray-900 rounded-t-lg">
        <div className="cursor-pointer flex items-center" onClick={toggleOpen}>
          <span className="font-semibold">File Transfers</span>
          {isOpen ? <FaChevronDown className="ml-2" /> : <FaChevronUp className="ml-2" />}
        </div>
        <button
          className="text-sm text-red-400 hover:text-red-600"
          onClick={clearTransfers}
          title="Clear All Transfers"
        >
          Clear All
        </button>
      </div>

      {/* Collapsible Transfer Items */}
      {isOpen && (
        <div className="p-4 overflow-y-auto overflow-x-hidden" style={{ maxHeight: "150px" }}>
          {sortedTransfers.length === 0 ? (
            <p className="text-gray-400">No active transfers</p>
          ) : (
            sortedTransfers.map((transfer) => (
              <div
                key={transfer.id}
                className={`mb-2 p-2 flex items-center justify-between border-b border-gray-700 transition duration-300 ${
                  transfer.completed ? "text-gray-400 opacity-60" : ""
                }`}
              >
                <div className="flex items-center flex-1">
                  {/* Display arrow icon based on type */}
                  {transfer.type === "upload" ? (
                    <FaArrowUp className="mr-1" title="Upload" />
                  ) : (
                    <FaArrowDown className="mr-1" title="Download" />
                  )}
                  <span className="truncate w-40">{transfer.name}</span>
                </div>
                <div className="flex items-center">
                  {transfer.completed ? (
                    <>
                      <FaCheckCircle className="text-green-400 ml-2" />
                      <button
                        onClick={() => removeTransfer(transfer.id)}
                        className="ml-2 hover:text-red-400"
                      >
                        <FaTimes />
                      </button>
                    </>
                  ) : transfer.failed ? (                    
                    <>
                      <span className="ml-2 flex items-center text-red-400" title="Failed">
                        <FaExclamationCircle className="mr-1" />
                        Failed
                      </span>                      
                      <button
                        onClick={() => removeTransfer(transfer.id)}
                        className="ml-2 hover:text-red-400"
                      >
                        <FaTimes />
                      </button>
                    </>
                  ) : transfer.aborted ? (
                    <>
                      <span className="ml-2 flex items-center text-yellow-400" title="Canceled">
                        <FaBan className="mr-1" />
                        Canceled
                      </span>                      
                      <button
                        onClick={() => removeTransfer(transfer.id)}
                        className="ml-2 hover:text-red-400"
                      >
                        <FaTimes className="text-white-400"/>
                      </button>
                    </>
                  ) : (
                    <span className="ml-2 flex items-center">
                      <FaSpinner className="animate-spin mr-2" />
                      {Math.round(transfer.progress)}%
                    </span>
                  )}
                  
                  {!transfer.completed && !transfer.aborted && !transfer.failed && (
                    <button
                      onClick={() => {
                        // Cancel the upload using the stored cancel token
                        transfer.cancelTokenSource.cancel("Upload canceled by user");
                        // Optionally, remove the transfer immediately from the UI
                        //removeTransfer(transfer.id);
                      }}
                      className="ml-2 hover:text-red-400"
                      title="Cancel Upload"
                    >
                      <FaTimes />
                    </button>
                  )}
                </div>
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
};

export default TransferList;